'use strict';

module.exports = require('./src/index');



//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0 1